<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2,mt-2"
        style=";margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-card class="box no-display" v-if="faculty_list != null">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Get Faculty Time Table</v-toolbar-title>
                <v-divider class="mx-4" color="white" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <!-- <v-card-text> -->
            <!-- <v-row justify="center">
          <v-col sm="3">
            <h3>Get Faculty Time Table</h3>
          </v-col>
        </v-row> -->
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-combobox dense required rounded v-model="curr_ay" :items="ay_list" item-text="Academic Year"
                        label="Academic Year" outlined
                        @change="show_tt = false; uid = null; tt_version = null; getTimeTableVersion()" persistent-hint
                        hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-combobox rounded multiple dense required v-model="stream" :items="stream_list" item-value="id"
                        item-text="name" label="Stream" outlined @change="show_tt = false; uid = null;" persistent-hint
                        hint="Please Select Stream" />
                </v-col>
                <v-col sm="2" v-if="curr_ay">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="tt_version" :items="tt_version_list"
                        item-text="name" item-value="id" label="Version" outlined persistent-hint
                        hint="Please Select Version" />
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-combobox dense rounded required v-model="uid" :items="faculty_list" item-text="name"
                        return-object label="Select Faculty" outlined persistent-hint hint="Please Select Faculty" />
                </v-col>
                <!-- <v-btn @click="fac_tt_v2">V2</v-btn> -->
                <v-col cols="12" sm="3" v-if="curr_ay && stream && tt_version && uid">
                    <v-btn class="button mt-6" @click="getTT(); show_tt_2 = false; show_tt_3 = false">View-1</v-btn>
                    <v-btn class="button mt-6" @click="fac_tt_v2(); show_tt = false; show_tt_3 = false">View-2</v-btn>
                    <v-btn class="button mt-6" @click="fac_tt_v3(); show_tt = false; show_tt_2 = false">View-3</v-btn>
                </v-col>
            </v-row>
            <!-- </v-card-text> -->
        </v-card>

        <faculty-time-table v-if="show_tt == true" :uid="uid.uid" :ay="curr_ay" :stream="stream"
            :tt_version="tt_version"></faculty-time-table>
        <faculty-time-table-view-2 v-if="show_tt_2 == true" :uid="uid.uid" :ay="curr_ay" :tt_version="tt_version"
            :stream="stream"></faculty-time-table-view-2>
        <faculty-time-table-view-3 v-if="show_tt_3 == true" :uid="uid.uid" :ay="curr_ay" :tt_version="tt_version"
            :stream="stream"></faculty-time-table-view-3>

        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Get Faculty Time-Table Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/-pC29MzXLqI?si=xJLh8mJNtW04nmin"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
import FacultyTimeTable from "./FacultyTimeTable";
import FacultyTimeTableView2 from "./FacultyTimeTableView2";
import FacultyTimeTableView3 from "./FacultyTimeTableView3";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        "faculty-time-table": FacultyTimeTable,
        "faculty-time-table-view-2": FacultyTimeTableView2,
        "faculty-time-table-view-3": FacultyTimeTableView3,
        Breadcrumbs
    },
    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            videoDialog:false,
            uid: null,
            ay_list: null,
            curr_ay: null,
            faculty_list: null,
            show_tt: false,
            show_tt_2: false,
            show_tt_3: false,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            stream_list: [],
            stream: null,
            tt_version_list: [],
            tt_version: null
        };
    },
    methods: {
        getTimeTableVersion() {
            const data = {
                ay: this.curr_ay,
            };
            axios
                .post("/timeTable/getTTVersion", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.tt_version_list = res.data.tt_version_list;
                    } else {
                        this.showSnackbar("error", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
        },
        getTT() {
            this.show_tt = true;
        },
        fac_tt_v3() {
            this.show_tt_3 = true
        },
        fac_tt_v2() {
            this.show_tt_2 = true
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    watch: {
        uid(newValue) {
            if (newValue) {
                localStorage.setItem('selectedFacultyName', newValue.name);
            }
        },
    },
    mounted() {
        //this.uid = localStorage.getItem("EPS-uid")
        axios
            .post("/timeTable/getFacultyTT")
            .then((res) => {
                this.ay_list = res.data.ay_list;
                this.curr_ay = res.data.curr_ay;
                this.faculty_list = res.data.faculty_list;
                this.stream_list = res.data.stream_list;
                if (this.curr_ay) {
                    this.getTimeTableVersion();
                }
            })
            .catch((error) => {
                alert("Somthing went wrong!!!");
            })
            .finally(() => {
                //stop loader
            });
    },
};
</script>
<style scoped>
.mytable /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.btn-grad {
    /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
}

.btn-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: black;
    box-shadow: 0 0 20px rgb(190, 187, 187);
    border-radius: 10px;
    display: block;
}

.btn-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: black;
    text-decoration: none;
}

.btn1-grad {
    background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
}

.btn1-grad {
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
}

.btn1-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}

@media print {
    .no-display {
        display: none !important;
    }

    /* .schlImg {
            width: 84%;
        } */
    @page {
        size: A3 landscape !important;
        scale: 50;
        margin-top: none !important;
        padding-top: none !important;
    }
}
</style>
